import React from 'react'

export default function RenderSection({ classNames, children, ...props }) {
    return (
        <section {...props} className={`rounded-[10px] bg-[white] p-2 sm:p-5 ${classNames || ''}`}>
            {children}
        </section>
    )
}
